import type { ApiProxyClient } from '../../types';
import { fetchVetAuthImage, uploadVetAuthImage } from './vetAuthImage';

export const cartApi: ApiProxyClient['cart'] = {
    fetchVetAuthImage,
    uploadVetAuthImage,
};
